/**
 * Created by hp on 2017/8/16.
 */
import React, {Component} from 'react';
import {Cells, Cell, CellBody, CellFooter} from 'react-weui';

class RelaySettingCell extends Component {
    render() {
        const {title, description, href} = this.props;

        return (
            <div className="relay-setting-cell">
                <Cells>
                    <Cell access href={href}>
                        <CellBody>
                            <p className="title">{title}</p>
                            <p className="desc">{description}</p>
                        </CellBody>
                        <CellFooter/>
                    </Cell>
                </Cells>
            </div>
        )
    }
}

export default RelaySettingCell;


// WEBPACK FOOTER //
// ./src/components/relaySetting/RelaySettingCell.js